import { APPLICANT_ATTRIBUTIONS } from 'cpool-constants';
import { z } from 'zod';

import { schemaGeneralEventApiResponse } from './GeneralResponse';

export const schemaDocumentAcknowledgmentChanged = schemaGeneralEventApiResponse.merge(
    z.object({
        payload: z.object({
            accepted: z.boolean(),
            key: z.string().min(1),
        }),
        type: z.literal('KreditDE_LoanRequest_DocumentAcknowledgmentChanged'),
    }),
);

export const schemaDocumentRemoved = schemaGeneralEventApiResponse.merge(
    z.object({
        payload: z.object({
            key: z.string().min(1),
        }),
        type: z.literal('KreditDE_LoanRequest_DocumentRemoved'),
    }),
);

export const schemaDocumentRenamed = schemaGeneralEventApiResponse.merge(
    z.object({
        payload: z.object({
            key: z.string().min(1),
            name: z.string().min(1),
        }),
        type: z.literal('KreditDE_LoanRequest_DocumentRenamed'),
    }),
);

export const schemaDocumentsDemanded = schemaGeneralEventApiResponse.merge(
    z.object({
        payload: z.object({
            attribution: z.nativeEnum(APPLICANT_ATTRIBUTIONS),
            documents: z.array(z.string().min(1)).min(1),
        }),
        type: z.literal('KreditDE_LoanRequest_DocumentsDemanded'),
    }),
);

export const schemaDocumentsRecorded = schemaGeneralEventApiResponse.merge(
    z.object({
        payload: z.object({
            attribution: z.nativeEnum(APPLICANT_ATTRIBUTIONS),
            documents: z
                .array(
                    z.object({
                        fileExtension: z.string().optional(),
                        key: z.string().min(1),
                        mimeType: z.string().min(1),
                        name: z.string().min(1),
                    }),
                )
                .min(1),
            uploader: z.string().nullish(),
        }),
        type: z.literal('KreditDE_LoanRequest_DocumentsRecorded'),
    }),
);

export const schemaDocumentEventApiResponse = z.discriminatedUnion('type', [
    schemaDocumentAcknowledgmentChanged,
    schemaDocumentRemoved,
    schemaDocumentRenamed,
    schemaDocumentsDemanded,
    schemaDocumentsRecorded,
]);

export type DucumentEventApiResponse = z.infer<typeof schemaDocumentEventApiResponse>;
export type DocumentAcknowledgmentChanged = z.infer<typeof schemaDocumentAcknowledgmentChanged>;
export type DocumentRemoved = z.infer<typeof schemaDocumentRemoved>;
export type DocumentRenamed = z.infer<typeof schemaDocumentRenamed>;
export type DocumentsDemanded = z.infer<typeof schemaDocumentsDemanded>;
export type DocumentsRecorded = z.infer<typeof schemaDocumentsRecorded>;
